<template>



            <div class="cart-list" v-if="Object.keys(cart).length > 0">
                <ul v-if="cart.cart.data">
                    <!-- {{ cart }} -->
                    <li class="cartdata" v-for="product in cart.cart.data">
                        <!-- {{ product }} -->
                        <div class="product-name">
                            {{ product.product_name }}<br />
                            <div class="packaging-qty">{{ product.packaging_qty }} {{ product.packaging_qty_unit }}</div>
                        </div>



                        <div class="cart-element">
                            <roastopus-cart-element-small :product="product" :key="product.product_id"></roastopus-cart-element-small>
                        </div>
                        <div class="product-price">
                            {{ parseFloat(product.price_plus_vat  * product.qty).toFixed(floatingPrecision) }} {{ product.currency }}

                        </div>
                    </li>
                    <li class="cartdata" v-if="cart.products_total_price_plus_vat == 0">
                        A kosár üres
                    </li>
                    <li class="last">

                        <div class="total_price">
                            {{ parseFloat(cart.products_total_price_plus_vat).toFixed(floatingPrecision)  | currency }}
                        </div>
                        <div class="checkout" v-if="!cartmenu_loading && cart.products_total_price_plus_vat > 0">
                            <a class="btn btn-checkout float-end" :href="route">  {{ btntext }}  </a>
                        </div>
                        <div class="checkout" v-if="!cartmenu_loading && cart.products_total_price_plus_vat == 0">
                            <a class="btn btn-checkout btn-disabled disabled float-end" :href="route">  {{ btntext }}  </a>
                        </div>
                        <div class="checkout" v-if="cartmenu_loading">
                            <a class="btn btn-checkout btn-loading disabled float-end" :href="route"><i class="fas fa-circle-notch fa-spin"></i>  Kosárművelet </a>
                        </div>
                    </li>
                </ul>


            </div>



</template>
<script>

import Vue from 'vue';
import mixin from '../../mixin.js'
export default {
    props: ['cart', 'route', 'cartmenu_loading', 'btntext'],
    mixins: [mixin],
    data () {
        return {
            menu_visible: this.value
        }
    },
    methods: {

        reload() {
            console.log('reload');
            this.$forceUpdate();
        }
    },
    mounted() {

        console.log('Cart(-list) Component mounted.');

    }
}
</script>
<style lang="css">
.img-hover {
    cursor: pointer;
}

</style>
